/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Audit_Log_RetentionInputs */



/**
* | output |
* | --- |
* | "Audit log retention" |
*
* @param {Sub_Downgrade_Audit_Log_RetentionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_audit_log_retention = /** @type {((inputs?: Sub_Downgrade_Audit_Log_RetentionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Audit_Log_RetentionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit-Log-Aufbewahrung")
	return /** @type {LocalizedString} */ ("Audit log retention")
});